/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Tr_Title_Translated_FromInputs */

const en_tr_title_translated_from = /** @type {(inputs: Tr_Title_Translated_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`translated from ${i?.language}`)
};

const de_tr_title_translated_from = /** @type {(inputs: Tr_Title_Translated_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`übersetzt aus ${i?.language}`)
};

/**
* | output |
* | --- |
* | "translated from {language}" |
*
* @param {Tr_Title_Translated_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tr_title_translated_from = /** @type {((inputs: Tr_Title_Translated_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tr_Title_Translated_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tr_title_translated_from(inputs)
	return en_tr_title_translated_from(inputs)
});